/**
 * Upgrade system configuration
 *
 * This file is auto-generated by the balance importer.
 * Do not edit manually - changes will be overwritten.
 *
 * Generated at: 2025-09-25T12:43:18.986Z
 */

import { ConfigType } from './ConfigType';

export interface UpgradeConfig {
  upg_id: string;
  name: string;
  unlock_lvl: number;
  max_lvl: number;
  effect_type_stat_key: string;
  effect_per_lvl: string | number;
  notes: string;
  cost_model: string;
  base_cost_coin: number;
  base_cost_pack: string;
  growth_mult: number;
  configType: ConfigType.UPGRADES;
}

export const upgradesData: Record<string, UpgradeConfig> = {
  u_laser_base: {
    upg_id: 'u_laser_base',
    name: 'Laser: Base Power',
    unlock_lvl: 1,
    max_lvl: 115,
    effect_type_stat_key: 'laser_flat_base',
    effect_per_lvl: 'flat=((i+1)*(i+2))/2',
    notes: 'базовый плоский урон',
    cost_model: 'bars_only',
    base_cost_coin: 0,
    base_cost_pack: '5×bar_stone',
    growth_mult: 1.12,
    configType: ConfigType.UPGRADES,
  },
  u_laser_radius: {
    upg_id: 'u_laser_radius',
    name: 'Laser Radius',
    unlock_lvl: 1,
    max_lvl: 16,
    effect_type_stat_key: 'mine_radius_mult',
    effect_per_lvl: 0.08,
    notes: 'радиус удара',
    cost_model: 'coins_only',
    base_cost_coin: 10,
    base_cost_pack: '–',
    growth_mult: 1.14,
    configType: ConfigType.UPGRADES,
  },
  u_laser_crit_ch1: {
    upg_id: 'u_laser_crit_ch1',
    name: 'Laser Crit Chance I',
    unlock_lvl: 1,
    max_lvl: 16,
    effect_type_stat_key: 'crit_chance',
    effect_per_lvl: 0.02,
    notes: 'кэп 75%',
    cost_model: 'coins_only',
    base_cost_coin: 1200,
    base_cost_pack: '–',
    growth_mult: 1.16,
    configType: ConfigType.UPGRADES,
  },
  u_craft_double: {
    upg_id: 'u_craft_double',
    name: 'Double Craft Chance',
    unlock_lvl: 12,
    max_lvl: 16,
    effect_type_stat_key: 'craft_double_chance',
    effect_per_lvl: 0.02,
    notes: 'шанс 2× выход',
    cost_model: 'coins_only',
    base_cost_coin: 1800,
    base_cost_pack: '–',
    growth_mult: 1.16,
    configType: ConfigType.UPGRADES,
  },
  u_rock_triple: {
    upg_id: 'u_rock_triple',
    name: 'Triple Rock Chance',
    unlock_lvl: 16,
    max_lvl: 16,
    effect_type_stat_key: 'triple_rock_chance',
    effect_per_lvl: 0.01,
    notes: 'шанс 3× камень/руда',
    cost_model: 'coins_only',
    base_cost_coin: 2400,
    base_cost_pack: '–',
    growth_mult: 1.16,
    configType: ConfigType.UPGRADES,
  },
  u_bomb_dmg1: {
    upg_id: 'u_bomb_dmg1',
    name: 'Bomb Damage I',
    unlock_lvl: 20,
    max_lvl: 16,
    effect_type_stat_key: 'bomb_dmg_mult',
    effect_per_lvl: 0.2,
    notes: 'общий мультик бомб',
    cost_model: 'coins+bars',
    base_cost_coin: 3000,
    base_cost_pack: '3×NeonSteel + 2×FluxGlass',
    growth_mult: 1.18,
    configType: ConfigType.UPGRADES,
  },
  u_ore_sell: {
    upg_id: 'u_ore_sell',
    name: 'Ore Sell Price',
    unlock_lvl: 24,
    max_lvl: 16,
    effect_type_stat_key: 'ore_sell_mult',
    effect_per_lvl: 0.1,
    notes: 'к цене продажи',
    cost_model: 'coins_only',
    base_cost_coin: 3500,
    base_cost_pack: '–',
    growth_mult: 1.18,
    configType: ConfigType.UPGRADES,
  },
  u_laser_crit_dmg1: {
    upg_id: 'u_laser_crit_dmg1',
    name: 'Laser Crit Damage I',
    unlock_lvl: 28,
    max_lvl: 11,
    effect_type_stat_key: 'crit_mult_bonus',
    effect_per_lvl: 0.1,
    notes: 'к мульту крита',
    cost_model: 'coins_only',
    base_cost_coin: 4000,
    base_cost_pack: '–',
    growth_mult: 1.17,
    configType: ConfigType.UPGRADES,
  },
  u_laser_dmg10: {
    upg_id: 'u_laser_dmg10',
    name: 'Laser Damage I',
    unlock_lvl: 32,
    max_lvl: 16,
    effect_type_stat_key: 'laser_dmg_mult',
    effect_per_lvl: 0.1,
    notes: 'общий мультик урона',
    cost_model: 'coins+bars',
    base_cost_coin: 4500,
    base_cost_pack: '3×NeonSteel + 2×FluxGlass',
    growth_mult: 1.18,
    configType: ConfigType.UPGRADES,
  },
  u_bomb_free: {
    upg_id: 'u_bomb_free',
    name: 'Free Bomb Chance',
    unlock_lvl: 36,
    max_lvl: 16,
    effect_type_stat_key: 'free_bomb_chance',
    effect_per_lvl: 0.01,
    notes: 'бесплатная бомба',
    cost_model: 'coins_only',
    base_cost_coin: 5500,
    base_cost_pack: '–',
    growth_mult: 1.18,
    configType: ConfigType.UPGRADES,
  },
  u_upg_gold_disc: {
    upg_id: 'u_upg_gold_disc',
    name: 'Upgrade Gold Prices ↓',
    unlock_lvl: 40,
    max_lvl: 16,
    effect_type_stat_key: 'upgrade_coin_cost_mult',
    effect_per_lvl: '-5%',
    notes: 'скидка на монетные апгрейды',
    cost_model: 'coins_only',
    base_cost_coin: 6000,
    base_cost_pack: '–',
    growth_mult: 1.18,
    configType: ConfigType.UPGRADES,
  },
  u_global_crit_ch: {
    upg_id: 'u_global_crit_ch',
    name: 'Global Crit Chance',
    unlock_lvl: 44,
    max_lvl: 16,
    effect_type_stat_key: 'crit_chance',
    effect_per_lvl: 0.02,
    notes: 'общий крит шанс',
    cost_model: 'coins_only',
    base_cost_coin: 6500,
    base_cost_pack: '–',
    growth_mult: 1.18,
    configType: ConfigType.UPGRADES,
  },
  u_laser_dmg15: {
    upg_id: 'u_laser_dmg15',
    name: 'Laser Damage II',
    unlock_lvl: 48,
    max_lvl: 16,
    effect_type_stat_key: 'laser_dmg_mult',
    effect_per_lvl: 0.15,
    notes: 'усиленный мультик',
    cost_model: 'coins+bars',
    base_cost_coin: 7000,
    base_cost_pack: '4×NeonSteel + 3×FluxGlass',
    growth_mult: 1.19,
    configType: ConfigType.UPGRADES,
  },
  u_laser_spd2a: {
    upg_id: 'u_laser_spd2a',
    name: 'Laser Attack Speed I',
    unlock_lvl: 52,
    max_lvl: 16,
    effect_type_stat_key: 'attack_speed',
    effect_per_lvl: 0.02,
    notes: 'софт-кэп на спид',
    cost_model: 'coins+bars',
    base_cost_coin: 7500,
    base_cost_pack: '3×NeonSteel + 2×FluxGlass',
    growth_mult: 1.18,
    configType: ConfigType.UPGRADES,
  },
  u_laser_crit_dmg12: {
    upg_id: 'u_laser_crit_dmg12',
    name: 'Laser Crit Damage II',
    unlock_lvl: 56,
    max_lvl: 11,
    effect_type_stat_key: 'crit_mult_bonus',
    effect_per_lvl: 0.12,
    notes: 'к мульту крита',
    cost_model: 'coins_only',
    base_cost_coin: 8000,
    base_cost_pack: '–',
    growth_mult: 1.19,
    configType: ConfigType.UPGRADES,
  },
  u_bomb_recharge: {
    upg_id: 'u_bomb_recharge',
    name: 'Bomb Recharge Rate',
    unlock_lvl: 60,
    max_lvl: 16,
    effect_type_stat_key: 'bomb_recharge_rate',
    effect_per_lvl: 0.01,
    notes: 'быстрее откат',
    cost_model: 'coins_only',
    base_cost_coin: 8500,
    base_cost_pack: '–',
    growth_mult: 1.18,
    configType: ConfigType.UPGRADES,
  },
  u_laser_dmg20a: {
    upg_id: 'u_laser_dmg20a',
    name: 'Laser Damage III',
    unlock_lvl: 62,
    max_lvl: 16,
    effect_type_stat_key: 'laser_dmg_mult',
    effect_per_lvl: 0.2,
    notes: 'ещё мощнее',
    cost_model: 'coins+bars',
    base_cost_coin: 9000,
    base_cost_pack: '4×NeonSteel + 3×FluxGlass',
    growth_mult: 1.2,
    configType: ConfigType.UPGRADES,
  },
  u_bomb_dmg40: {
    upg_id: 'u_bomb_dmg40',
    name: 'Bomb Damage II',
    unlock_lvl: 65,
    max_lvl: 16,
    effect_type_stat_key: 'bomb_dmg_mult',
    effect_per_lvl: 0.4,
    notes: 'сильный бомб буст',
    cost_model: 'coins+bars',
    base_cost_coin: 9500,
    base_cost_pack: '4×NeonSteel + 3×FluxGlass',
    growth_mult: 1.2,
    configType: ConfigType.UPGRADES,
  },
  u_bomb_crit_dmg8: {
    upg_id: 'u_bomb_crit_dmg8',
    name: 'Bomb Crit Damage I',
    unlock_lvl: 68,
    max_lvl: 16,
    effect_type_stat_key: 'bomb_crit_mult_bonus',
    effect_per_lvl: 0.08,
    notes: 'к мульту крита бомб',
    cost_model: 'coins_only',
    base_cost_coin: 10000,
    base_cost_pack: '–',
    growth_mult: 1.19,
    configType: ConfigType.UPGRADES,
  },
  u_laser_supercrit_ch1: {
    upg_id: 'u_laser_supercrit_ch1',
    name: 'Laser Super Crit Chance',
    unlock_lvl: 70,
    max_lvl: 16,
    effect_type_stat_key: 'supercrit_chance',
    effect_per_lvl: 0.01,
    notes: 'шанс супер-крита',
    cost_model: 'coins_only',
    base_cost_coin: 10500,
    base_cost_pack: '–',
    growth_mult: 1.19,
    configType: ConfigType.UPGRADES,
  },
  u_laser_spd2b: {
    upg_id: 'u_laser_spd2b',
    name: 'Laser Attack Speed II',
    unlock_lvl: 72,
    max_lvl: 16,
    effect_type_stat_key: 'attack_speed',
    effect_per_lvl: 0.02,
    notes: 'софт-кэп на спид',
    cost_model: 'coins+bars',
    base_cost_coin: 11000,
    base_cost_pack: '4×NeonSteel + 2×FluxGlass',
    growth_mult: 1.2,
    configType: ConfigType.UPGRADES,
  },
  u_upg_caps: {
    upg_id: 'u_upg_caps',
    name: 'Increase Upgrade Caps',
    unlock_lvl: 75,
    max_lvl: 3,
    effect_type_stat_key: 'upg_cap_plus',
    effect_per_lvl: '+1 cap',
    notes: 'глобально ↑капы',
    cost_model: 'coins_only',
    base_cost_coin: 25000,
    base_cost_pack: '–',
    growth_mult: 1.3,
    configType: ConfigType.UPGRADES,
  },
  u_laser_dmg28: {
    upg_id: 'u_laser_dmg28',
    name: 'Laser Damage IV',
    unlock_lvl: 78,
    max_lvl: 16,
    effect_type_stat_key: 'laser_dmg_mult',
    effect_per_lvl: 0.28,
    notes: 'поздний мультик',
    cost_model: 'coins+bars',
    base_cost_coin: 12000,
    base_cost_pack: '5×NeonSteel + 3×FluxGlass',
    growth_mult: 1.22,
    configType: ConfigType.UPGRADES,
  },
  u_bomb_crit_dmg12: {
    upg_id: 'u_bomb_crit_dmg12',
    name: 'Bomb Crit Damage II',
    unlock_lvl: 80,
    max_lvl: 16,
    effect_type_stat_key: 'bomb_crit_mult_bonus',
    effect_per_lvl: 0.12,
    notes: '—',
    cost_model: 'coins_only',
    base_cost_coin: 12500,
    base_cost_pack: '–',
    growth_mult: 1.21,
    configType: ConfigType.UPGRADES,
  },
  u_laser_supercrit_dmg10: {
    upg_id: 'u_laser_supercrit_dmg10',
    name: 'Laser Super Crit Damage',
    unlock_lvl: 82,
    max_lvl: 11,
    effect_type_stat_key: 'supercrit_mult_bonus',
    effect_per_lvl: 0.1,
    notes: 'к мульту супер-крита',
    cost_model: 'coins_only',
    base_cost_coin: 13000,
    base_cost_pack: '–',
    growth_mult: 1.21,
    configType: ConfigType.UPGRADES,
  },
  u_laser_crit_ch2: {
    upg_id: 'u_laser_crit_ch2',
    name: 'Laser Crit Chance II',
    unlock_lvl: 85,
    max_lvl: 16,
    effect_type_stat_key: 'crit_chance',
    effect_per_lvl: 0.02,
    notes: 'общий крит шанс',
    cost_model: 'coins_only',
    base_cost_coin: 13500,
    base_cost_pack: '–',
    growth_mult: 1.21,
    configType: ConfigType.UPGRADES,
  },
  u_laser_dmg35: {
    upg_id: 'u_laser_dmg35',
    name: 'Laser Damage V',
    unlock_lvl: 88,
    max_lvl: 21,
    effect_type_stat_key: 'laser_dmg_mult',
    effect_per_lvl: 0.35,
    notes: 'эндгейм мультик',
    cost_model: 'coins+bars',
    base_cost_coin: 14000,
    base_cost_pack: '6×NeonSteel + 4×FluxGlass',
    growth_mult: 1.24,
    configType: ConfigType.UPGRADES,
  },
  u_obelisk_armor: {
    upg_id: 'u_obelisk_armor',
    name: 'Obelisk Armor ↓',
    unlock_lvl: 90,
    max_lvl: 16,
    effect_type_stat_key: 'enemy_armor_reduction',
    effect_per_lvl: '-2%',
    notes: 'снижает броню врага',
    cost_model: 'coins_only',
    base_cost_coin: 15000,
    base_cost_pack: '–',
    growth_mult: 1.22,
    configType: ConfigType.UPGRADES,
  },
  u_laser_ultracrit_ch: {
    upg_id: 'u_laser_ultracrit_ch',
    name: 'Laser Ultra Crit Chance',
    unlock_lvl: 92,
    max_lvl: 16,
    effect_type_stat_key: 'ultracrit_chance',
    effect_per_lvl: 0.01,
    notes: 'шанс ультра-крита',
    cost_model: 'coins_only',
    base_cost_coin: 15500,
    base_cost_pack: '–',
    growth_mult: 1.22,
    configType: ConfigType.UPGRADES,
  },
  u_meter_fill: {
    upg_id: 'u_meter_fill',
    name: 'Meter Fill Rate',
    unlock_lvl: 95,
    max_lvl: 16,
    effect_type_stat_key: 'meter_fill_rate_mult',
    effect_per_lvl: '×2',
    notes: 'множитель шкалы',
    cost_model: 'coins_only',
    base_cost_coin: 16000,
    base_cost_pack: '–',
    growth_mult: 1.22,
    configType: ConfigType.UPGRADES,
  },
  u_bomb_ultracrit_ch: {
    upg_id: 'u_bomb_ultracrit_ch',
    name: 'Bomb Ultra Crit Chance',
    unlock_lvl: 98,
    max_lvl: 16,
    effect_type_stat_key: 'bomb_ultracrit_chance',
    effect_per_lvl: 0.01,
    notes: '—',
    cost_model: 'coins_only',
    base_cost_coin: 16500,
    base_cost_pack: '–',
    growth_mult: 1.22,
    configType: ConfigType.UPGRADES,
  },
  u_craft_triple: {
    upg_id: 'u_craft_triple',
    name: 'Triple Craft Chance',
    unlock_lvl: 100,
    max_lvl: 16,
    effect_type_stat_key: 'craft_triple_chance',
    effect_per_lvl: 0.01,
    notes: 'шанс 3× выход',
    cost_model: 'coins_only',
    base_cost_coin: 17000,
    base_cost_pack: '–',
    growth_mult: 1.22,
    configType: ConfigType.UPGRADES,
  },
  u_laser_dmg_per_card: {
    upg_id: 'u_laser_dmg_per_card',
    name: 'Laser Dmg per Card',
    unlock_lvl: 102,
    max_lvl: 16,
    effect_type_stat_key: 'laser_dmg_per_card',
    effect_per_lvl: '+1%/card',
    notes: 'суммируется по картам',
    cost_model: 'coins_only',
    base_cost_coin: 18000,
    base_cost_pack: '–',
    growth_mult: 1.23,
    configType: ConfigType.UPGRADES,
  },
};

/**
 * Get UpgradeConfig by upg_id
 */
export function getUpgrades(id: string): UpgradeConfig | undefined {
  return upgradesData[id];
}

/**
 * Get all UpgradeConfig entries
 */
export function getAllUpgrades(): UpgradeConfig[] {
  return Object.values(upgradesData);
}

/**
 * Check if UpgradeConfig exists
 */
export function hasUpgrades(id: string): boolean {
  return id in upgradesData;
}
